import React, { Component} from 'react';
import { apiFetch } from "../../../api/apiFetch";
import { getUserId } from "../../../api/session";

//Custom Components
import { Spin } from '../Utilities/Spin'
import { ProfileBasic } from './ProfileBasic'
//import { ProfileContacts } from './ProfileContacts'
//import { ProfileInterests } from './ProfileInterests'
//import { ProfileBucketList } from './ProfileBucketList'
//import { ProfileStrengthsAndWeaknesses } from './ProfileStrengthsAndWeaknesses'
//import { ProfileResponsibilities } from './ProfileResponsibilities'
//import { ProfileLifeEvents } from './ProfileLifeEvents'
//import { ProfileSiteOptions } from './ProfileSiteOptions'

//Material UI
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

//Data Services
import { getUserProfile, getProfileImage, removeStrength, addStrength, removeWeakness, addWeakness, getSiteOptions } from '../../DataServices/UserService'
import { getPhotoThumb } from '../../DataServices/PhotoService'

const a11yProps = (index, id) => {
    return {
        id: `simple-tab-${index}-${id}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`profile-tabpanel-${index}`}
            aria-labelledby={`profile-tab-${index}`}
            style={{ minWidth: "130px" }}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

export class Profile extends Component {
    constructor(props) {
        super(props);
        this.props.setToken.bind(this);
        this.state = {
            userprofile: [],
            loading: true,
            tabValue: 0,
        };
    }

    componentDidMount() {
        this.getUserProfile();
        this.getSiteOptions();
    }

    //Get Data
    getUserProfile = async () => {
        const data = await getUserProfile(this.props.appIdentifier);
        if (data === "error") {
            this.props.setToken('');
            localStorage.clear();
        }
        else {
            this.setState({
                userprofile: data,
                loading: false
            });
            this.getProfileImage();
        }
    }
    getProfileImage = async () => {
        const data = await getProfileImage();
        if (data) {
            this.setState(
                state => {
                    state.userprofile.imageB64 = data.thumb;
                    state.userprofile.avatarB64 = data.thumb;
                    return state;
                }
            );
        }
    }
    getSiteOptions = async () => {
        const data = await getSiteOptions(this.props.user.userID);
        if (data) {
            this.setState({ siteOptions: data });
            if (data.coverPhotoID) {
                const thumb = await getPhotoThumb(data.coverPhotoID);
                if (thumb) {
                    this.setState(
                        state => {
                            state.siteOptions.coverPhoto = thumb;
                            return state;
                        }
                    );
                }
            }
        }
    }

    //Event Handlers-----------------
    handleTabChange = (event, newValue) => {
        this.setState({ tabValue: newValue });
    }
    handleHeadlineChange(data) {
        this.setState(
            prevState => {
                let uprofile = { ...prevState.userprofile };
                uprofile.demographics.personalHeadline = data;
                return { uprofile };
            }
        )
    }
    handleFirstNameChange(data) {
        this.setState(
            prevState => {
                let uprofile = { ...prevState.userprofile };
                uprofile.firstName = data;
                return { uprofile };
            }
        )
    }
    handleLastNameChange(data) {
        this.setState(
            prevState => {
                let uprofile = { ...prevState.userprofile };
                uprofile.lastName = data;
                return { uprofile };
            }
        )
    }
    handleUpdateProfile = (b64) => {
        this.setState(
            state => {
                state.userprofile.imageB64 = b64;
                return state;
            }
        );

        let user = this.props.user;
        user.avatar = b64;
        this.props.setUserInfo(user);

    }

    updateSiteOptions = (siteOptions) => {
        this.setState({ siteOptions });
    }
    updatePublicAttributes = (ignore, profile) => {
        const userprofile = this.state.userprofile;
        userprofile.publicAttributes = profile.publicAttributes;
        this.setState({ userprofile });
    }
    updateData = (profile) => {
        this.setState({ profile });
    }
    //render funcs
    TabContainer = () => {
        return (
            <Box sx={{ width: '100%', height: { xs: "calc(100vh - 108px)", sm: '100%' }, minHeight: "400px", background: this.props.dark ? "#050505" : "#eee" }} className={this.props.dark ? "dark" : "light"} >
                <Box sx={{ borderBottom: this.props.dark && "1px solid #151515", background: theme => this.props.dark ? "#151515" : theme.palette.secondary.main }} elevation={this.props.dark ? 0 : 8}>
                    <Tabs variant="scrollable" scrollButtons="auto" sx={{ minHeight: "36px", maxWidth: "fit-content", mx: "auto" }} allowScrollButtonsMobile indicatorColor="secondary" value={this.state.tabValue} onChange={(e, newValue) => this.handleTabChange(e, newValue)} aria-label="profile tabs">
                        <Tab label="Personal Info" {...a11yProps(0)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />
{/*                        <Tab label="Contact Info" {...a11yProps(1)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*{this.props.appIdentifier === 'LS' &&*/}
                        {/*    <Tab label="Responsibilities" {...a11yProps(2)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*}*/}
                        {/*{this.props.appIdentifier === 'LS' &&*/}
                        {/*    <Tab label="Strengths and Weaknesses" {...a11yProps(3)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*}*/}
                        {/*{this.props.appIdentifier === 'LS' &&*/}
                        {/*    <Tab label="Interests" {...a11yProps(4)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*}*/}
                        {/*{this.props.appIdentifier === 'LS' &&*/}
                        {/*    <Tab label="Background" {...a11yProps(5)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*}*/}
                        {/*{this.props.appIdentifier === 'LS' &&*/}
                        {/*    <Tab label="Goals and Future Desires" {...a11yProps(6)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*}*/}
                        {/*{this.props.appIdentifier === 'LS' &&*/}
                        {/*    <Tab label="User Site Options" {...a11yProps(7)} sx={{ paddingTop: "0px", paddingBottom: "0px", minHeight: "36px", fontSize: ".8rem", color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.common.white }} />*/}
                        {/*}*/}
                    
                    </Tabs>
                </Box>
                <TabPanel style={{ display: "contents" }} value={this.state.tabValue} index={0}>
                    {this.profileBasic()}
                </TabPanel>
                {/*<TabPanel style={{ display: "contents" }} value={this.state.tabValue} index={1}>*/}
                {/*    {this.profileContact()}*/}
                {/*</TabPanel>*/}
                {/*{this.props.appIdentifier === 'LS' &&*/}

                {/*{this.props.appIdentifier === 'LS' &&*/}
                {/*    <TabPanel style={{ display: "contents" }} value={this.state.tabValue} index={7}>*/}
                {/*        {this.userSiteOptions()}*/}
                {/*    </TabPanel>*/}
                {/*}*/}
                
            </Box>
        )
    }
    profileBasic = () => {
        return (
            <ProfileBasic
                user={this.props.user}
                appIdentifier={this.props.appIdentifier}
                profile={this.state.userprofile}
                dark={this.props.dark}
                updateData={this.updatePublicAttributes}
                setUserInfo={this.props.setUserInfo}
                handleUpdateProfile={this.handleUpdateProfile}
                deleteEmail={this.deleteEmail}
                deletePhone={this.deletePhone}
                deleteAddress={this.deleteAddress}
                updateEmail={this.updateEmail}
                updatePhone={this.updatePhone}
                updateAddress={this.updateAddress}
                updateMyDob={this.updateMyDob}
                updateMyJobAnniversary={this.updateMyJobAnniversary}
                updateMyWeddingAnniversary={this.updateMyWeddingAnniversary}
                handlePersonalChange={this.handlePersonalChange}
                fullScreen={this.props.fullScreen}
                updateData={this.updateData}
            />
        )
    }
    //profileContact = () => {
    //    return (
    //        <ProfileContacts
    //            appIdentifier={this.props.appIdentifier}
    //            profile={this.state.userprofile}
    //            updateData={this.updatePublicAttributes}
    //            dark={this.props.dark}
    //            setUserInfo={this.props.setUserInfo}
    //            deleteEmail={this.deleteEmail}
    //            deletePhone={this.deletePhone}
    //            deleteAddress={this.deleteAddress}
    //            updateEmail={this.updateEmail}
    //            updatePhone={this.updatePhone}
    //            updateAddress={this.updateAddress}
    //        />
    //    )
    //}

    //userSiteOptions = () => {
    //    if (this.state.siteOptions) {
    //        return (
    //            <ProfileSiteOptions
    //                appIdentifier={this.props.appIdentifier}
    //                siteOptions={this.state.siteOptions}
    //                dark={this.props.dark}
    //                handleUpdateProfile={this.handleUpdateSiteOptions}
    //                user={this.props.user}
    //                updateSiteOptions={this.updateSiteOptions}
    //            />
    //        )
    //    }
    //    return null;


    //}
    content = () => {
        let contents = this.state.loading
            ? <Spin open={this.state.loading} />
            :
            this.profileBasic()

        return (
            <Box dark={this.props.dark} >
                {contents}
            </Box>
        )
    }

    //main component render
    render() {
        return this.content();
    }
}